import { FETCH_SPOT_FAILURE, FETCH_SPOT_LOADING, FETCH_SPOT_SUCCESS } from '../Types/spotReducer';
import api from '../config/api';

const API_WP = process.env.REACT_APP_API_URL;
export const getSpots = () => {
  return dispatch => {
    dispatch({
      type: FETCH_SPOT_LOADING
    });
    api
      .get(`${API_WP}Desk/parking`)
      .then(response => {
        const { data } = response.data;
        dispatch({
          type: FETCH_SPOT_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        const errorMsg = error.message;
        dispatch({
          type: FETCH_SPOT_FAILURE,
          payload: errorMsg
        });
      });
  };
};
